import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isChangePlanzoneRequestFailure() {
      return getState().isFailure;
    },
    isChangePlanzoneRequestPending() {
      return getState().isPending;
    },
    isChangePlanzoneRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
